namespace GeniuzPOS.ReportMasterData {
    export class Report_1334Columns {
        static columnsKey = 'ReportMasterData.Report_1334';
    }
}
